var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterWave2 = function SvgFooterWave2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 145"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005CA9",
    d: "M1440 0H0v145h1440z",
    shapeRendering: "crispEdges"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0v79.5c462-61.396 766.5-114 1440 0V0z"
  })));
};
export default SvgFooterWave2;